/**
* 404
* Author: dong xing
* Date: 2020/3/1
* Time: 18:51
* Email: dong.xing@outlook.com
*/

<template>
  <div class="exception-404">
    <h1>404</h1>
  </div>
</template>

<script>
export default {
  name: 'Exception404'
}
</script>

<style scoped>

</style>
